/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { EmployeePayPeriodJobRoleRate } from './EmployeePayPeriodJobRoleRate';
import {
    EmployeePayPeriodJobRoleRateFromJSON,
    EmployeePayPeriodJobRoleRateFromJSONTyped,
    EmployeePayPeriodJobRoleRateToJSON,
    EmployeePayPeriodJobRoleRateToJSONTyped,
} from './EmployeePayPeriodJobRoleRate';

/**
 * 
 * @export
 * @interface EmployeePayPeriodSummary
 */
export interface EmployeePayPeriodSummary {
    /**
     * A deterministic identifier for the report.
     * @type {string}
     * @memberof EmployeePayPeriodSummary
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    employeeId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeePayPeriodSummary
     */
    startDate: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeePayPeriodSummary
     */
    endDate: ShiftiePlainDate;
    /**
     * 
     * @type {string}
     * @memberof EmployeePayPeriodSummary
     */
    payrollId: string;
    /**
     * The total number of paid hours, excluding overtime
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    totalBasePaidHours: number;
    /**
     * The total number of overtime paid hours
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    totalOvertimePaidHours: number;
    /**
     * Total number of paid hours, including overtime
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    totalPaidHours: number;
    /**
     * Total number of paid leave hours
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    totalPaidLeaveHours?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodSummary
     */
    estimatedTotal: number;
    /**
     * 
     * @type {Array<EmployeePayPeriodJobRoleRate>}
     * @memberof EmployeePayPeriodSummary
     */
    hourlyRatesByJobRoleAndPayType: Array<EmployeePayPeriodJobRoleRate>;
}

/**
 * Check if a given object implements the EmployeePayPeriodSummary interface.
 */
export function instanceOfEmployeePayPeriodSummary(value: object): value is EmployeePayPeriodSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('payrollId' in value) || value['payrollId'] === undefined) return false;
    if (!('totalBasePaidHours' in value) || value['totalBasePaidHours'] === undefined) return false;
    if (!('totalOvertimePaidHours' in value) || value['totalOvertimePaidHours'] === undefined) return false;
    if (!('totalPaidHours' in value) || value['totalPaidHours'] === undefined) return false;
    if (!('estimatedTotal' in value) || value['estimatedTotal'] === undefined) return false;
    if (!('hourlyRatesByJobRoleAndPayType' in value) || value['hourlyRatesByJobRoleAndPayType'] === undefined) return false;
    return true;
}

export function EmployeePayPeriodSummaryFromJSON(json: any): EmployeePayPeriodSummary {
    return EmployeePayPeriodSummaryFromJSONTyped(json, false);
}

export function EmployeePayPeriodSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeePayPeriodSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'startDate': ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': ShiftiePlainDateFromJSON(json['endDate']),
        'payrollId': json['payrollId'],
        'totalBasePaidHours': json['totalBasePaidHours'],
        'totalOvertimePaidHours': json['totalOvertimePaidHours'],
        'totalPaidHours': json['totalPaidHours'],
        'totalPaidLeaveHours': json['totalPaidLeaveHours'] == null ? undefined : json['totalPaidLeaveHours'],
        'estimatedTotal': json['estimatedTotal'],
        'hourlyRatesByJobRoleAndPayType': ((json['hourlyRatesByJobRoleAndPayType'] as Array<any>).map(EmployeePayPeriodJobRoleRateFromJSON)),
    };
}

  export function EmployeePayPeriodSummaryToJSON(json: any): EmployeePayPeriodSummary {
      return EmployeePayPeriodSummaryToJSONTyped(json, false);
  }

  export function EmployeePayPeriodSummaryToJSONTyped(value?: EmployeePayPeriodSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'payrollId': value['payrollId'],
        'totalBasePaidHours': value['totalBasePaidHours'],
        'totalOvertimePaidHours': value['totalOvertimePaidHours'],
        'totalPaidHours': value['totalPaidHours'],
        'totalPaidLeaveHours': value['totalPaidLeaveHours'],
        'estimatedTotal': value['estimatedTotal'],
        'hourlyRatesByJobRoleAndPayType': ((value['hourlyRatesByJobRoleAndPayType'] as Array<any>).map(EmployeePayPeriodJobRoleRateToJSON)),
    };
}

